import { createContext } from "react";

const RouterContext = createContext();

export default RouterContext;
